import { IAddToNicheParams } from "../../services/NichesService";
import { IAppAction } from "../appAction";

export const nichesActions = {
  FETCH_NICHES: "FETCH_NICHES",
  FETCH_NICHES_SUCCESS: "FETCH_NICHES_SUCCESS",
  FETCH_NICHES_ERROR: "FETCH_NICHES_ERROR",

  ADD_TO_NICHE: "ADD_TO_NICHE",
  ADD_TO_NICHE_SUCCESS: "ADD_TO_NICHE_SUCCESS",
  ADD_TO_NICHE_ERROR: "ADD_TO_NICHE_ERROR"
};

export const fetchNiches = (): IAppAction => ({
  type: nichesActions.FETCH_NICHES
});

export const fetchNichesSuccess = (payload: any): IAppAction => ({
  type: nichesActions.FETCH_NICHES_SUCCESS,
  payload
});

export const fetchNichesError = (error: Error): IAppAction => ({
  type: nichesActions.FETCH_NICHES_ERROR,
  payload: error
});

export const addToNiche = (payload: IAddToNicheParams): IAppAction => ({
  type: nichesActions.ADD_TO_NICHE,
  payload
});

export const addToNicheSuccess = (payload: any): IAppAction => ({
  type: nichesActions.ADD_TO_NICHE_SUCCESS,
  payload
});

export const addToNicheError = (payload: Error): IAppAction => ({
  type: nichesActions.ADD_TO_NICHE_ERROR
});
